/**
 * Provides a context for managing state and selectors related to VMS Control components
 * @module AvalancheEventContext
 */
import React, { createContext, useContext, useRef, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Context for managing state and selectors related to VMS control components
 * @type {React.Context}
 */
const AvalancheEventContext = createContext();

/**
 * Provider component for AvalancheEventContext.
 * @param {object} props - Component props.
 * @param {React.ReactNode} props.children - Child components wrapped by the provider.
 * @returns {React.ReactNode} Provider component.
 */
export const AvalancheEventContextProvider = ({ children }) => {
  //const dispatch = useDispatch();
  const [fullContextData, setFullContextData] = useState([]);

  // Structure the context values for the provider
  const stateValues = { fullContextData };

  const stateSetters = { setFullContextData };

  const selectorValues = {};

  const memoizedValues = {};

  // Combine values into a single context value
  const contextValue = {
    ...stateValues,
    ...stateSetters,
    ...selectorValues,
    ...memoizedValues,
  };

  return <AvalancheEventContext.Provider value={contextValue}>{children}</AvalancheEventContext.Provider>;
};

/**
 * Hook for consuming AvalancheEventContext.
 * @returns {object} Context value.
 */
export const useAvalancheEventContext = () => useContext(AvalancheEventContext);
